export default class PaymentDetailsAbstractServices {
  static getPaymentDetailsSelectionRefData() {
    logger.error('PaymentDetails:: getPaymentDetailsSelectionRefData() not implemented');
  }

  static getPaymentDetailsPageReferenceData() {
    logger.error('PaymentDetails:: getPaymentDetailsPageReferenceData() not implemented');
  }

  static getPremiumImpactPageReferenceData() {
    logger.error('PaymentDetails:: getPremiumImpactPageReferenceData() not implemented');
  }
}
